import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model"

export class CreateMovimientoExpedienteRequest extends CreateKeyValueRequest {
  public idExpediente!: number
  public idUsuario!: number
  public idEstadoMovimientoExpediente!: number
  public idEscrito!: number
  public idArchivo!: number
  public fecha!: string

}
